import React, { useRef, useState } from 'react';
import styles from './CommentActions.module.scss';
import useOutsideClick from '../../../hooks/useOutsideClick';
import Emoji from '../../Emoji/Emoji';
import { Icon } from '../../../../engage/components/Icon';
import Modal from '../../Modal';

const ReactionPicker = ({ handleReaction, isMobileView, isVideoReaction = false }) => {
  const [isActive, setIsActive] = useState(false);
  const reactionRef = useRef();
  useOutsideClick(reactionRef, () => setIsActive(false));

  const handleToggle = () => {
    setIsActive(!isActive);
  };

  const clickReaction = item => {
    setIsActive(false);
    handleReaction(item);
  };

  const emojis = [
    { unicode: '0x2764' },
    { unicode: '0x1F64C' },
    { unicode: '0x1F525' },
    { unicode: '0x1F44F' },
    { unicode: '0x1F622' },
    { unicode: '0x1F60D' },
    { unicode: '0x1F632' },
    { unicode: '0x1F602' },
    { unicode: '0x1F44D' },
  ];

  return (
    <div className={styles.addReaction} ref={reactionRef}>
      {isVideoReaction && (
        <>
          <div className={styles.emojiItem} onClick={() => clickReaction({ unicode: '0x1F44D' })}>
            <Emoji unicode={'0x1F44D'} />
          </div>
          <div className={styles.emojiItem} onClick={() => clickReaction({ unicode: '0x1F60D' })}>
            <Emoji unicode={'0x1F60D'} />
          </div>
          <div className={styles.emojiItem} onClick={() => clickReaction({ unicode: '0x1F525' })}>
            <Emoji unicode={'0x1F525'} />
          </div>
        </>
      )}
      <Icon src="addEmoji" verticalAlign="middle" className={styles.addReactionIcon} onClick={handleToggle} />
      {isActive && isMobileView && (
        <Modal open={isActive} onClose={handleToggle} className={styles.reactionPickerModal}>
          <div className={styles.reactionPicker}>
            {emojis.map(item => (
              <div key={item.unicode} className={styles.emojiItem} onClick={() => clickReaction(item)}>
                <Emoji key={item.unicode} unicode={item.unicode} />
              </div>
            ))}
          </div>
        </Modal>
      )}
      {isActive && !isMobileView && (
        <div className={styles.reactionPicker}>
          {emojis.map(item => (
            <div key={item.unicode} className={styles.emojiItem} onClick={() => clickReaction(item)}>
              <Emoji key={item.unicode} unicode={item.unicode} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ReactionPicker;
